import React, { useState, useCallback, useMemo } from 'react';
import classNames from 'classnames';

import { MessageBarType, MessageBar } from '@fluentui/react/lib/MessageBar';
import { getFloatingBannerStyle } from '@bingads-webui-campaign-react/smart-component-util';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

export const useFloatingBanner = () => {
  const [state, setState] = useState({
    isShow: false,
    msgInfo: '',
    msgType: MessageBarType.warning,
  });

  const classes = useDefaultStyles(getFloatingBannerStyle);

  const showWarningMessage = useCallback((msg) => {
    setState({
      isShow: true,
      msgInfo: msg,
      msgType: MessageBarType.warning,
    });
  }, []);

  const hideFloatingBanner = useCallback(() => {
    setState({
      isShow: false,
      msgInfo: '',
      msgType: MessageBarType.info,
    });
  }, []);

  const floatingBanner = useMemo(() => {
    if (state.isShow) {
      return (
        <div className={classNames(classes.floatingBanner, 'floating-banner')}>
          <MessageBar messageBarType={state.msgType} onDismiss={hideFloatingBanner}>
            {state.msgInfo}
          </MessageBar>
        </div>
      );
    }

    return null;
  }, [hideFloatingBanner, state, classes]);

  return {
    floatingBanner,

    showWarningMessage,
    hideFloatingBanner,
  };
};
